"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monte-marenzo": {
    "8ad8cc77": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "beriocco": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2454541f": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "butto-inferiore": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "140cf006": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "butto-superiore": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c56638d7": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "capatina": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3b1b0129": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "carobbio": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72ad726f": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "ceregallo": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a486b3ae": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "colombara": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "86d30f34": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "costa": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4d0183c6": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "fornace": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eab5220f": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "portico": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38dc370a": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "prato-marzio": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6f0163c4": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "ravanaro": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "29aa510d": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "san-paolo": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2f2c30e1": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "spaiano": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "758777f9": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "torre": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c414772": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "skipSearch": false
    }],
    "turni": [{
      "hkey": "2ea5cb77",
      "slug": "monte-marenzo",
      "name": "Monte Marenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;